import { Component, HostBinding } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserStateService } from '@frontend/sports/user/feature';
import { Observable, map } from 'rxjs';

@Component({
    selector: 'bs-quick-bet',
    templateUrl: './quick-bet.component.html',
    styles: [],
    standalone: false,
})
export class QuickBetComponent {
    @HostBinding('class') className = 'quick-bet';

    oddsDisplayFormat$: Observable<OddsDisplayFormat>;

    constructor(userState: UserStateService) {
        this.oddsDisplayFormat$ = userState.userState$().pipe(map((state) => state.oddsFormat || OddsDisplayFormat.EU));
    }
}
